import { Component, EventEmitter, Output, HostBinding } from '@angular/core';

@Component({
    selector: 'jhi-add-requerant-header',
    templateUrl: './add-requerant-header.component.html',
    styleUrls: ['./add-requerant-header.component.scss']
})
export class AddRequerantHeaderComponent {
    @Output()
    onAdd: EventEmitter<void> = new EventEmitter();

    @Output()
    onClose: EventEmitter<void> = new EventEmitter();

    @HostBinding('class.adding')
    isAdding = false;

    edit() {
        this.isAdding = true;
        this.onAdd.emit();
    }

    close() {
        this.isAdding = false;
        this.onClose.emit();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/add-requerant-header/add-requerant-header.component.ts